import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.showTab('organizations-on-sindi')
  }
  
  switchTab(event) {
    event.preventDefault()
    
    const targetId = event.currentTarget.dataset.target
    
    this.element.querySelectorAll('.nav-link').forEach(link => {
      link.classList.remove('active')
    })
    event.currentTarget.classList.add('active')
    
    this.showTab(targetId)
  }
  
  showTab(targetId) {
    this.element.querySelectorAll('.tab-content-panel').forEach(panel => {
      panel.style.display = 'none'
      panel.classList.remove('active')
    })
    
    const targetPanel = this.element.querySelector(`#${targetId}`)
    if (targetPanel) {
      targetPanel.style.display = 'block'
      targetPanel.classList.add('active')
    }
  }
}